<template>
    <div>
        <el-form label-position="right" ref="form" :model="form.model" :validate-on-rule-change="false" label-width="120px">
            <el-row class="bottom20">
                <el-row class="column-name" justify="start">
                    <span>计费记录</span>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="客户名称" prop="customerName">
                                <el-input v-model="form.model.customerName" :disabled="true" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="合同名称" prop="contractName">
                                <el-input v-model="form.model.contractName" :disabled="true" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24">
                            <el-form-item label="合同备注" prop="contractComment">
                                <el-input v-model="form.model.contractComment" :disabled="true" size="small" type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="计费项" prop="name">
                                <el-input v-model="form.model.itemName" :disabled="true" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="月份" prop="sid">
                                <el-input v-model="form.model.month" :disabled="true" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="form.model.recordSubs != null">
                        <el-row v-for="recordSub in form.model.recordSubs" :key="recordSub.resourceId">
                            <el-col :xs="24" :sm="24" :md="12" :lg="12" v-if="recordSub.resourceId != null && recordSub.resourceId !== 0">
                                <el-form-item label="资产编号" prop="sid">
                                    <el-input :value="recordSub.resourceTag" :disabled="true" size="small"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                <el-form-item :label="`使用量(${recordSub.calculateUnit})`" prop="amount">
                                    <el-input-number v-model="recordSub.amount" :disabled="!editable" size="small" class="width100">
                                    </el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="记录人员" prop="realName">
                                <el-input v-model="form.model.vm_realName" :disabled="true" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="记录时间" prop="ts">
                                <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                                v-model="form.model.ts" :disabled="true"
                                                type="date"
                                                placeholder="记录时间" size="small">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24">
                            <el-form-item label="备注" prop="memo">
                                <el-input v-model="form.model.memo" :maxlength="250" placeholder="限250字符" :disabled="!editable" size="small" type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>

        <Attachment ownerTable="billing_contract_item_record"
                    :docType="docType"
                    :ownerId="form.model.id"
                    :existed="form.model.id != null"
                    :disabled="!(form.model.id != null)"></Attachment>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {formatDate} from 'element-ui/src/utils/date-util'
    import Emitter from 'element-ui/src/mixins/emitter'
    import {merge} from "@/util/common";
    import BillingServer from '@/api/billing';
    import Attachment from "@/components/attachment";
    import {
        COMPONENT_DETAIL, COMPONENT_MAIN,
        TAB_LIST, TAB_DETAIL,
        OPERATION_LIST_DEFAULT,
        FN_SET_TAB, FN_SET_OPERATION,
    } from "./contract.item.record.common";
    import {AuthInfo} from "@/util/user/authInfo";
    export default {
        name: COMPONENT_DETAIL,
        componentName: COMPONENT_DETAIL,
        mixins: [Emitter],
        components: {Attachment},
        props: ["data"],
        data() {
            return {
                form: {
                    /**
                     *
                     * id: null,
                     * itemId: null,
                     * month: null,
                     * attach: null,
                     * memo: null,
                     * userId: null,
                     * ts: null,
                     *
                     * customerName: null,
                     * contractName: null,
                     * contractComment: null,
                     * itemName: null,
                     * content: null,
                     * recordSubs: null,
                     *
                     * vm_realName: null,
                     */
                    _init_model: {},
                    model: {},
                },
            };
        },
        computed: {
            docType() {
                return this.form.model.content === 'POWER' ? "BILLINGPOWER" : "BILLINGNETWORK";
            },
            editable() {
                return true;
            },
        },
        watch: {
          data: {
              deep: true,
              handler(data) {
                  if (data != null) {
                      this.loadFormModel(data.id, data.itemId, data.month, data.content);
                  }
              },
          }
        },
        methods: {
            setFormModel(model) {
                this.form._init_model = merge(true, {}, model);
                this.form.model = merge(true, {}, model);
            },
            formIsDirty() {
                let initModel = this.form._init_model;
                let model = this.form.model;
                return !_.isEqual(initModel, model);
            },
            resetForm() {
                this.form.model = merge(true, {}, this.form._init_model);
            },
            async loadFormModel(id, itemId, month, content) {
                let res = await BillingServer.contractItemRecord.getDetail(id, itemId, month, content);
                if (!res.data.success) {
                    this.$message.error(res.data.responseMessage);
                    return ;
                }
                let detail = res.data.data;
                detail.vm_realName = AuthInfo.userRealName;
                this.setFormModel(detail);
            },
            toAdd() {

            },
            async saveAdd() {
                let data = this.form.model;
                data.userId = AuthInfo.userId;
                data.ts = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let res = await BillingServer.contractItemRecord.addDetail(data);
                if (res.data.success) {
                    this.$message.success('保存成功！');
                    let data = res.data.data;
                    this.loadFormModel(data.id, data.itemId, data.month, data.content);
                } else {
                    this.$message.error(res.data.responseMessage);
                }
            },
            async saveEdit() {
                var data = this.form.model;
                data.userId = AuthInfo.userId;
                data.ts = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                let res = await BillingServer.contractItemRecord.modifyDetail(data['id'], data);
                if (res.data.success) {
                    this.$message.success('保存成功！');
                    let data = res.data.data;
                    this.loadFormModel(data.id, data.itemId, data.month, data.content);
                } else {
                    this.$message.error(res.data.responseMessage);
                }
            },
            cancelEdit() {
                this.dispatch(COMPONENT_MAIN, FN_SET_TAB, TAB_LIST);
                this.dispatch(COMPONENT_MAIN, FN_SET_OPERATION, OPERATION_LIST_DEFAULT);
            },
        },
    }
</script>

<style scoped>

</style>